import { useEffect, useState } from "react";
import dayjs from "dayjs";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useAuth } from "src/hooks/useAuth";
import { IconLine } from "src/icons";
import {
  Title,
  Topic,
  Desc,
  Button,
} from "src/modules/order/shipping-order/components";
import { v4 as uuidv4 } from "uuid";
const { Grid } = require("@mui/material");

const CustomerInfo = ({ info }) => {
  const { user } = useAuth();
  const [isAdmin, setIsAdmin] = useState(true);

  useEffect(() => {
    const url = window.location.pathname;
    if (url) setIsAdmin(user?.role_id === 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleActivateLine = () => {
    const orderId = window.location.pathname.substring(
      window.location.pathname.lastIndexOf("/") + 1,
    );
    const callback = `/seller-shipping/detail/${orderId}`;
    const state = encodeURIComponent(
      JSON.stringify({ uuid: uuidv4(), callback }),
    );
    const params = `response_type=code&client_id=${
      process.env.REACT_APP_CLIENT_LINE_ID_SERVICE
    }&redirect_uri=${
      window.location.origin
    }/line&bot_prompt=aggressive&prompt=consent&scope=profile%20openid&state=${state}`;
    window.location.href = `https://access.line.me/oauth2/v2.1/authorize?${params}`;
  };

  if (info === undefined) return;

  return (
    <Grid container>
      <Grid item container xs={12} justifyContent="space-between">
        <Grid item xs={3}>
          <Title>ข้อมูลลูกค้า</Title>
        </Grid>

        {!isAdmin &&
        info?.status?.value !== "failed" &&
        info?.status?.value !== "delivered" ? (
          <Grid item xs={9} display="flex" justifyContent="flex-end">
            <Button onClick={() => handleActivateLine()}>
              <IconLine
                color="#5ac363"
                projectPrice
                className="icon-line"
                style={{ marginRight: "10px" }}
                width={18}
                height={18}
                fill="#ffffff"
              />
              ติดตามสถานะผ่าน LINE
            </Button>
          </Grid>
        ) : null}
      </Grid>

      {isAdmin ? (
        <>
          <Grid
            item
            xs={12}
            sm={6}
            lg={6}
            sx={{ mt: { xs: 1, sm: 2, md: 2, lg: 3 } }}
          >
            <Topic>Order Number</Topic>
            <Desc
              isLink
              onClick={() => window.open(`/order/detail/${info?.order?._id}`)}
            >
              {info?.order?.orderNumber || "-"}
            </Desc>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            lg={6}
            sx={{ mt: { xs: 1, sm: 2, md: 2, lg: 3 } }}
          >
            <Topic>QT Number</Topic>
            <Desc>{info?.order?.qtNumber || "-"}</Desc>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            lg={6}
            sx={{ mt: { xs: 1, sm: 2, md: 2, lg: 3 } }}
          >
            <Topic>ชื่อลูกค้า</Topic>
            <Desc>{`${info?.order?.shippingAddress?.name}`}</Desc>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            lg={6}
            sx={{ mt: { xs: 1, sm: 2, md: 2, lg: 3 } }}
          >
            <Topic>เลขที่ภาษี</Topic>
            <Desc>{info?.order?.taxInvoiceAddress?.taxId || "-"}</Desc>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            lg={6}
            sx={{ mt: { xs: 1, sm: 2, md: 2, lg: 3 } }}
          >
            <Topic>อีเมล</Topic>
            <Desc>{info?.order?.user?.email || "-"}</Desc>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            lg={6}
            sx={{ mt: { xs: 1, sm: 2, md: 2, lg: 3 } }}
          >
            <Topic>เบอร์โทรศัพท์</Topic>
            <Desc>{info?.order?.shippingAddress?.tel || "-"}</Desc>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            lg={6}
            sx={{ mt: { xs: 1, sm: 2, md: 2, lg: 3 } }}
          >
            <Topic>ที่อยู่</Topic>
            <Desc>
              {!!info?.order?.shippingAddress?.address
                ? `${info?.order?.shippingAddress?.address || ""} ${
                    info?.order?.shippingAddress?.subdistrict || ""
                  } ${info?.order?.shippingAddress?.district || ""} ${
                    info?.order?.shippingAddress?.province || ""
                  } ${info?.order?.shippingAddress?.zipcode || ""}
                `
                : "-"}
            </Desc>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            lg={6}
            sx={{ mt: { xs: 1, sm: 2, md: 2, lg: 3 } }}
          >
            <Topic>ออเดอร์อ้างอิง</Topic>
            <Desc>{info?.order?.refDraftOrder?.running_number || "-"}</Desc>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            lg={6}
            sx={{ mt: { xs: 1, sm: 2, md: 2, lg: 3 } }}
          >
            <Topic>วันที่สั่งซื้อ</Topic>
            <Desc>
              {dayjs(info?.order?.createdAt).format("DD-MM-YYYY HH:mm")}
            </Desc>
          </Grid>

          <Grid container xs={6}>
            <Grid
              item
              xs={12}
              sm={6}
              lg={6}
              sx={{ mt: { xs: 1, sm: 2, md: 2, lg: 3 } }}
            >
              <Topic>จัดส่งภายในวันที่</Topic>
              <Desc>
                {dayjs(info?.order?.scheduleDate).format("DD-MM-YYYY") || "-"}
              </Desc>
            </Grid>
          </Grid>

          <Grid container xs={12} sm={6} mt={2}>
            <Button
              variant="outlined"
              className="MuiButton-location-google-maps"
              sx={{ ml: 0 }}
              onClick={() =>
                window.open(
                  `https://www.google.com/maps?q=${info?.order?.shippingAddress?.recipients?.coordinates?.lat},${info?.order?.shippingAddress?.recipients?.coordinates?.lng}`,
                  "_blank",
                )
              }
            >
              <LocationOnIcon fontSize="small" />
              ดูที่อยู่ ลูกค้าบน Google Maps
            </Button>
          </Grid>
        </>
      ) : (
        <>
          <Grid
            item
            xs={12}
            sm={6}
            lg={6}
            sx={{ mt: { xs: 1, sm: 2, md: 2, lg: 3 } }}
          >
            <Topic>ชื่อลูกค้า</Topic>
            <Desc>{`${info?.order?.shippingAddress?.name}`}</Desc>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            lg={6}
            sx={{ mt: { xs: 1, sm: 2, md: 2, lg: 3 } }}
          >
            <Topic>เบอร์โทรศัพท์</Topic>
            <Desc>{info?.order?.shippingAddress?.tel || "-"}</Desc>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            lg={6}
            sx={{ mt: { xs: 1, sm: 2, md: 2, lg: 3 } }}
          >
            <Topic>ที่อยู่</Topic>
            <Desc>
              {`${info?.order?.shippingAddress?.address || ""} ${
                info?.order?.shippingAddress?.subdistrict || ""
              } ${info?.order?.shippingAddress?.district || ""} ${
                info?.order?.shippingAddress?.province || ""
              } ${info?.order?.shippingAddress?.zipcode || ""}
                ` || "-"}
            </Desc>
          </Grid>

          <Grid container xs={6}>
            <Grid
              item
              xs={12}
              sm={6}
              lg={6}
              sx={{ mt: { xs: 1, sm: 2, md: 2, lg: 3 } }}
            >
              <Topic>วันที่สั่งซื้อ</Topic>
              <Desc>
                {dayjs(info?.order?.createdAt).format("DD-MM-YYYY HH:mm")}
              </Desc>
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              lg={6}
              sx={{ mt: { xs: 1, sm: 2, md: 2, lg: 3 } }}
            >
              <Topic>จัดส่งภายในวันที่</Topic>
              <Desc>
                {dayjs(info?.order?.scheduleDate).format("DD-MM-YYYY") || "-"}
              </Desc>
            </Grid>
          </Grid>

          <Grid container xs={12} sm={6} mt={2}>
            <Button
              variant="outlined"
              className="MuiButton-location-google-maps"
              sx={{ ml: 0 }}
              onClick={() =>
                window.open(
                  `https://www.google.com/maps?q=${info?.order?.shippingAddress?.recipients?.coordinates?.lat},${info?.order?.shippingAddress?.recipients?.coordinates?.lng}`,
                  "_blank",
                )
              }
            >
              <LocationOnIcon fontSize="small" />
              ดูที่อยู่ ลูกค้าบน Google Maps
            </Button>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default CustomerInfo;
